import React from 'react';

import HowItWorksStep1SVG from "../../components/Images/HowItWorksStep1SVG"
import HowItWorksStep2SVG from "../../components/Images/HowItWorksStep2SVG"
import HowItWorksStep3SVG from "../../components/Images/HowItWorksStep3SVG"
import HowItWorksStep4SVG from "../../components/Images/HowItWorksStep4SVG"
import  KavitaImg from "../../pages/WritersBenefit/Author/Images/Kavita.jpg"
import  WordsImg from "../../pages/WritersBenefit/Author/Images/Words.jpg"
import  AnandImg from "../../pages/WritersBenefit/Author/Images/Anand.jpg"
import { commonFAQ } from '../../constants';



const marathi = {
  introduction_heading :'लेखक होण्याचे तुमचे स्वप्न आता करा पूर्ण!  ',
  create_novel_button_text: "तुमच्या मनातल्या कल्पनेच्या अंकुराचे रुपांतर करा एक सुंदर कादंबरीत. ",
  rewards_title: <>  मोबदला आणि फायदे</>,
  rewards_para_text: <><span>वर्षाला प्रत्येक कादंबरी साठी कमीत कमी १ लाख तर जास्तीत जास्त १० लाख मिळवण्याची संधी!</span></>,
  rewardsAndBenefitsArray: [
    {
      heading: 'New Story Bonus 🖋️',
      subHeading: <>जेव्हा तुम्ही किमान शब्द प्रकाशित करता तेव्हा प्रत्येक करार केलेल्या मूळ कथेला हा पुरस्कार दिला जातो</>,
      tableHeadings: ['किमान शब्द', ' मोबदला'],
      table: [
        {
          wordCount: '30,000',
          reward: '₹3०००',
        },
      ],
      note: <>"कोणतीही कॉपी किंवा आक्षेपार्ह्य लेखन नाही</>,
      extraNotes: [
        {
          no: 1,
          text: 'लेखकाने लेखक लाभ कार्यक्रमासाठी (WBP) अर्ज केला पाहिजे आणि करारावर स्वाक्षरी केली पाहिजे. ',
        },
        {
          no: 2,
          text: ' करार 5000 शब्दांच्या लेखनानंतर केला जाऊ शकतो. ',
        },
        {
          no: 3,
          text: 'स्वाक्षरी केल्यानंतर, जर पुस्तक आमच्या किमान लेखन गुणवत्ता मानकांची पूर्तता करत असेल, तर ते पुढील महिन्याच्या पहिल्या आठवड्यात सुरू होणाऱ्या पेमेंट सायकलसाठी मंजूर केले जाईल. ',
        },
      ],
    },
    {
      heading: 'Daily Update Bonus ⭐',
      subHeading: <>लाभाची रक्कम ही प्रत्येक महिन्याला प्रकाशित झालेली शब्दसंख्या आणि गुणवत्ता यावर अवलंबून असले</>,
      tableHeadings: ['शब्द संख्या  (मासिक)', ' लाभ'],
      table: [
        {
          wordCount: '30,000 पेक्षा कमी ',
          reward: 'पेमेंट नाही          ',
        },

        {
          wordCount: '30,000 - 50,000 ',
          reward: '₹2000',
        },
        {
          wordCount: '50,000 पेक्षा जास्त',
          reward: '₹६०००',
        },
        
      ],
      note: <>लेखक एका महिन्यात जास्तीत जास्त 5 दिवस प्रकाशित प्रकरणे चुकवू शकतो.</>,
      extraNotes: [
        {
          no: 1,
          text: 'लेखकाचा लेखक लाभ कार्यक्रम अर्ज मंजूर झाल्यानंतर, पात्र बक्षीस प्रत्येक महिन्याच्या 1 तारखेला मोजले जाईल. ',
        },
        {
          no: 2,
          text: ' ज्यामध्ये, प्राप्त झालेल्या रिवॉर्डसाठी पेमेंट सायकल दर महिन्याच्या 8 तारखेला असेल / करारावर महिन्याच्या 1 तारखेपूर्वी स्वाक्षरी केली असेल',
        },
        
      ],
    },
   
    {
      heading: 'Completion Bonus 🚀',
      subHeading: 'जेव्हा तुम्ही किमान शब्द प्रकाशित करता तेव्हा प्रत्येक स्वाक्षरी केलेल्या मूळ कथेला हा पुरस्कार दिला जातो',
      tableHeadings: ['शब्द संख्या (एकंदरीत) |', ' पुरस्कार'],
      table: [
        {
          wordCount: ' 2,50,000 पेक्षा कमी ',
          reward: 'पेमेंट नाही ',
        },
        {
          wordCount: '2,50,000 - 3,50,000',
          reward: '₹५०००',
        },
        {
          wordCount: '3,50,000 - 5,00,000',
          reward: '₹१०,०००',
        },
        {
          wordCount: '5,00,000 पेक्षा जास्त',
          reward: '₹२५,०००',
        },
      ],
      note: <>कथेचा शेवट समाधानकारक असावा</>,
      extraNotes: [
        {
          no: 1,
          text: <> आमच्या अधिकृत खात्यावर ईमेल पाठवा: writers@pocketfm.com, विषय शीर्षकासह: पुस्तकाचे नाव, लेखकाचे नाव, पूर्णत्व बोनसची विनंती </>
        },
        {
          no: 2,
          text:<> करारावर लवकरात लवकर 5000 शब्दांवर स्वाक्षरी केली जाऊ शकते</>,
        },
        {
          no: 3,
          text:<>पुस्तक आमच्या लेखन गुणवत्तेच्या मार्गदर्शक तत्त्वांची पूर्तता करते की नाही हे मूल्यांकन करण्यासाठी संपादकीय तपासणीनंतर देय मंजूर केले जाईल.

          </>,
        },
      ],
    },
  ],
  deadline_content: <>   <span>प्रोग्राममध्ये प्रवेश करण्याची अंतिम मुदत   </span><span role="img" aria-label="finish flag">🏁</span>   </>,
  deadline_to_enter_button: "पॉकेट नॉव्हेलचे लेखक व्हा ",
  deadline_date:31,
  deadline_date_suffix:"",
  days_or: "दिवस किंवा" ,
  months_to_go:" महिने बाकी आहेत!! ",
  monthInWords:"ऑक्टोबर",
  month:9,
  year: 2022,
  deadline_subheading: 'एकदा कार्यक्रमाचा भाग झाल्यावर, तुम्ही वरील सर्व बोनससाठी आजीवन पात्र असाल"',
  howItWorksArray : [
    {
      step: '1',
      instruction:<>प्रथम कथेचे 30,000 शब्द लिहा आणि करारासाठी अर्ज कर।</>,
        stepSVG:HowItWorksStep1SVG
    },
    {
      step: '2',
      instruction:<>करारावर स्वाक्षरी करा आणि नवीन कथेचा बोनस मिळवा। </>,
        stepSVG:HowItWorksStep2SVG
  
    },
    {
      step: '3',
      instruction:<>दररोज नवीन भाग लिहा आणि दर महिन्याला "दररोज प्रकाशन बोनस" प्राप्त करा 💸 💰</>,
        stepSVG:HowItWorksStep3SVG
  
    },
    {
      step: '4',
      instruction:<>एकदा तुम्ही 2,50,000 शब्द पूर्ण केले आणि वाचकांचा उत्तम प्रतिसाद आला की, तुम्ही तुमची कथा ऑडिओबुकमध्ये बनवण्यास पात्र आहात. मंजूरीनंतर, परफॉर्मन्स बोनस प्राप्त करा 💰 💸</>,
        stepSVG:HowItWorksStep4SVG
  
    },
  ],
  step: "पायरी",
  popularWritersArray : [
    {
      writerName: 'Kavita verma',
      novelName: 'Mein Tere Chandani चे लेखक',
      plays: '9.8M',
      words: '820K',
      writerImgSrc: KavitaImg,
    },
    {
      writerName: 'Words Queen',
      novelName: 'Fake Love चे लेखक',
      plays: '7.7M',
      words: '540K',
      writerImgSrc: WordsImg,
    },
    {
      writerName: 'Anand Usha Borkar',
      novelName: 'Megh - Ek Shraap चे लेखक',
      plays: '1.8M',
      words: '720K',
      writerImgSrc: AnandImg,
    },
  ],
  popular_writter: 'लोकप्रिय लेखक',


  faq: <strong>सामान्यपणे विचारले जाणारे प्रश्न </strong>,
  frequentlyAskedQuestionsArray : commonFAQ,
  
  write_home_earn_stable_income_text :'स्वतःच्या घरातून लिहा आणि निश्चित कमाईचे साधन मिळवा.',
  write_home_earn_stable_income_subheading : "या नव्या प्रवासाला करा सुरुवात. हजारो वाचकांचे प्रेम आणि बरोबरच १० लाखांपर्यंत कमाई. ",
  create_new_novel :"आजच नवी कादंबरी लिहायला सुरुवात करा."
 
}

// console.log(hindi.writer_dream_text)
export default marathi;